import styled from 'styled-components';

export const Grade = styled.div`
  width:100%;
  margin:15px;
  border:4px solid #fff;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0,0,0,.05);
`;
